export { standardSchemaResolver as resolver } from "@hookform/resolvers/standard-schema";
